import adminMiddleware from "@/components/data/admin/ducks/middleware"
import userMiddleware from "@/components/data/ducks/middleware"
import internalMiddleware from "@/components/data/internal/ducks/middleware"
import volunteerMiddleware from "@/components/data/volunteer/ducks/middleware"

export default [volunteerMiddleware, internalMiddleware, adminMiddleware, userMiddleware]
